// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__UDDYf"};